module.exports = __webpack_public_path__ + "img/chess.37d28ca3.png";